/**
 * Voice Memo Status Badge Component
 * Displays status badge for voice memo items
 */

import { Badge } from '@/components/ui/badge';
import type { VoiceMemo } from './types';

interface StatusBadgeProps {
  status: VoiceMemo['status'];
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = {
    unprocessed: { label: 'New', color: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/20' },
    transcribing: { label: 'Transcribing...', color: 'bg-orange-500/10 text-orange-500 border-orange-500/20' },
    transcribed: { label: 'Transcribed', color: 'bg-blue-500/10 text-blue-500 border-blue-500/20' },
    analyzed: { label: 'Analyzed', color: 'bg-green-500/10 text-green-500 border-green-500/20' },
    filed: { label: 'Filed', color: 'bg-purple-500/10 text-purple-500 border-purple-500/20' },
    ignored: { label: 'Ignored', color: 'bg-gray-500/10 text-gray-500 border-gray-500/20' }
  };

  const { label, color } = config[status] || config.unprocessed;

  return (
    <Badge className={`border ${color}`}>
      {label}
    </Badge>
  );
}
